export default __webpack_public_path__ + "static/media/showcase-img.38c1052d.png";